import { Fragment, useEffect } from 'react'
import {
  Box,
  Container,
  Divider,
  Typography,
  Tooltip,
  IconButton,
  Button
} from '@mui/material'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { useCart } from '../../context/Cart/CartContext'
import CartItemList from '../../components/CartItemList/CartItemList'
import { formatter } from '../../utils/auxFunc'

const CartContainer = () => {
  const {
    cart,
    getCart,
    addToComponent,
    removeToComponent,
    removeByProductId,
    removeByComponentId,
    clear,
    getTotalAmount
  } = useCart()

  let navigate = useNavigate()

  const handleReturn = () => {
    navigate('/')
  }

  useEffect(() => {
    getCart()
  }, [getCart])

  return (
    <>
      <Container>
        <Box display="flex" alignItems="center" minHeight="60px">
          <Box>
            <Tooltip title="Volver">
              <IconButton
                size="large"
                aria-label="volver"
                aria-controls="volver-carrito"
                aria-haspopup="false"
                color="inherit"
                onClick={handleReturn}
              >
                <ArrowBackIosIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <Typography
            variant="h5"
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexGrow={1}
          >
            Carrito
          </Typography>
          <Box>
            <Tooltip title="Carrito">
              <IconButton
                size="large"
                aria-label="carrito"
                aria-controls="logo-carrito"
                aria-haspopup="false"
                color="inherit"
              >
                {cart?.length > 0 ? (
                  <ShoppingCartIcon color="secondary" />
                ) : (
                  <ShoppingCartOutlinedIcon color="secondary" />
                )}
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Container>

      <Divider />
      <Container>
        {cart?.length > 0 ? (
          <Fragment>
            <Container sx={{ marginBottom: '2rem' }}>
              {cart?.map((product) => {
                return (
                  <CartItemList
                    product={product}
                    removeByProductId={removeByProductId}
                    removeByComponentId={removeByComponentId}
                    addToComponent={addToComponent}
                    removeToComponent={removeToComponent}
                    key={product.idProduct}
                  />
                )
              })}
              <Container maxWidth="sm">
                {cart?.length > 1 && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    fullWidth
                    onClick={clear}
                    sx={{ textTransform: 'capitalize', mt: 4 }}
                  >
                    Vaciar carrito
                  </Button>
                )}
              </Container>
            </Container>
            <Box>
              <Divider />
              <Container maxWidth="sm">
                <Box display="flex" justifyContent="space-between" py="1rem">
                  <Typography
                    variant="body1"
                    color="secondary"
                    sx={{ fontWeight: 'bold' }}
                  >
                    Subtotal:
                  </Typography>
                  <Typography
                    variant="body1"
                    color="secondary"
                    sx={{ fontWeight: 'bold' }}
                  >
                    {formatter().format(getTotalAmount())}
                  </Typography>
                </Box>
                <NavLink to="/cart/checkout" style={{ textDecoration: 'none' }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    sx={{ textTransform: 'capitalize', marginBottom: '1rem' }}
                  >
                    Iniciar Compra
                  </Button>
                </NavLink>
              </Container>
            </Box>
          </Fragment>
        ) : (
          <Box
            height="calc(100vh - 50px)"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Typography variant="h4" color="initial" mb={2}>
              Tu carrito está vacío!
            </Typography>
            <Link to="/home" style={{ textDecoration: 'none' }}>
              <Button variant="contained" color="secondary" size="large">
                Buscar productos
              </Button>
            </Link>
          </Box>
        )}
      </Container>
    </>
  )
}

export default CartContainer
